function compareObjects(A, B) {
  const keys = Object.keys(A);
  const differentKeys = [];

  for (const key of keys) {
    const valueA = A[key];
    const valueB = B[key];

    if (typeof valueA === "object" && valueA !== null && "id" in valueA) {
      // If valueA is an object with an 'id', compare the 'id' values
      if (typeof valueB === "object" && valueB !== null && "id" in valueB) {
        if (valueA.id !== valueB.id) {
          differentKeys.push(key);
        }
      } else {
        differentKeys.push(key);
      }
    } else if (Array.isArray(valueA) && Array.isArray(valueB)) {
      // console.log("we are here both are array", valueA, valueB);
      // console.log("valueA.length", valueA.length, "valueB.length", valueB.length);
      // Check if arrays have the same length
      if (valueA.length !== valueB.length) {
        // console.log("we are here A.length !== B.length");
        differentKeys.push(key);
      } else if (valueA.length !== 0) {
        const setA = new Set(valueA.map((item) => item.id));
        const setB = new Set(valueB.map((item) => item.id));
        if (setA.size !== setB.size) {
          differentKeys.push(key);
        }
        // else if (setA.size === 1 && setA.has(null) && setB.size === 1 && setB.has(null)) {
        //   console.log("both are null only");
        // }
        else if (setB.has(null)) {
          differentKeys.push(key);
        } else {
          for (let id of setA) {
            if (!setB.has(id)) {
              differentKeys.push(key);
            }
          }
        }
      } else {
        console.log("unknown condition %%%");
      }
    } else {
      // Compare primitive values or null
      if (valueA !== valueB) {
        differentKeys.push(key);
      }
    }
  }

  return differentKeys;
}

export default compareObjects;
